// extracted by mini-css-extract-plugin
export default {"rootContainer":"_2q7694SdUQVAxvaqv_ouzT","icon":"_1Ao7x65M570jdOKuHOQkLb","title":"_1P_4KoAFXZiEqDK5zlU-Yv"};